import { Slot } from "@radix-ui/react-slot";
import clsx from "clsx";
import { forwardRef, HTMLAttributes } from "react";
import classes from "./visually-hidden.module.css";

export type VisuallyHiddenProps = HTMLAttributes<HTMLSpanElement> & {
  asChild?: boolean;
};

export const VisuallyHidden = forwardRef<HTMLDivElement, VisuallyHiddenProps>(
  ({ asChild, className, ...props }, ref) => {
    const Comp = asChild ? Slot : "span";

    return (
      <Comp
        ref={ref}
        className={clsx(classes.visuallyHidden, className)}
        {...props}
      />
    );
  },
);

VisuallyHidden.displayName = "VisuallyHidden";
